<template>
    <div>
        <vs-row class="date-filter">
            <vs-col vs-tooltip="'col - 6'" vs-type="flex" vs-justify="center" vs-align="center" vs-w="6" vs-sm="12" vs-xs="12">
                <vs-row>
                    <vs-col vs-tooltip="'col - 6'" vs-type="flex" vs-justify="center" vs-align="center" vs-w="5" vs-sm="5" vs-xs="5">
                        <span style="margin-right:5px">FROM</span>
                    </vs-col>
                    <vs-col vs-tooltip="'col - 6'" vs-type="flex" vs-justify="center" vs-align="center" vs-w="7" vs-sm="7" vs-xs="7">
                        <datepicker class="input-span-placeholder vs-input--placeholder normal vs-input" v-model="from" :format="customFormatter" @closed="setFrom"></datepicker>
                    </vs-col>
                </vs-row>
            </vs-col>
            <vs-col vs-tooltip="'col - 6'" vs-type="flex" vs-justify="center" vs-align="center" vs-w="6" vs-sm="12" vs-xs="12">
                 <vs-row>
                    <vs-col vs-tooltip="'col - 6'" vs-type="flex" vs-justify="center" vs-align="center" vs-w="5" vs-sm="5" vs-xs="5">
                        <span style="margin-right:5px; margin-left:5px">TO</span>
                    </vs-col>
                    <vs-col vs-tooltip="'col - 6'" vs-type="flex" vs-justify="center" vs-align="center" vs-w="7" vs-sm="7" vs-xs="7">
                        <datepicker class="input-span-placeholder vs-input--placeholder normal vs-input" v-model="to" :format="customFormatter" :highlighted="highlighted" :disabledDates="disabledDates"></datepicker>
                        <i class="far fa-calendar-alt date-icon"></i>
                    </vs-col>
                </vs-row>
            </vs-col>
        </vs-row>
    </div>
</template>
<script>
import moment from 'moment';

export default {
    data() {
        return {
            from: '',
            to: '',
            isMobile: window.innerWidth <= 835,
            highlighted:{},
            disabledDates:{}
        }
    },
    methods:{
        customFormatter(date) {
            return moment(date).format('MM/DD/YYYY');
        },
        setFrom(){
            this.$store.commit("setFrom7", this.customFormatter(new Date(this.from)));
            let date = new Date(this.$store.state.from_7);
            this.to = this.customFormatter(date.setDate(date.getDate() + 6));
            this.$store.commit("setTo7", this.customFormatter(new Date(this.to)));
            
            this.highlighted = {
                from: new Date(this.$store.state.from_7),
                to: new Date(this.$store.state.to_7)
            };

            this.disabledDates = {
                to: new Date(this.$store.state.from_7),
                from: new Date(this.$store.state.to_7),
            }
        }
    },
    mounted(){
        let date = new Date();
        this.to = this.customFormatter(date.setDate(date.getDate() -1));
        this.from = this.customFormatter(date.setDate(date.getDate() - 6));

        this.$store.commit("setFrom7", this.from);
        this.$store.commit("setTo7", this.to);

        this.highlighted = {
            from: new Date(this.$store.state.from_7),
            to: new Date(this.$store.state.to_7)
        };

        this.disabledDates = {
            to: new Date(this.$store.state.from_7),
            from: new Date(this.$store.state.to_7),
        }
    }
}
</script>

